(function () {
  'use strict';

  function initStickyClass() {
    var shell = document.querySelector('.ss-shell');
    if (!shell) return;
    var onScroll = function () {
      shell.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function updateMegaTop() {
    var header = document.querySelector('.ss-header');
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--ss-mega-top', Math.round(bottom + 8) + 'px');
  }

  function initMegaMenu() {
    var detailsList = document.querySelectorAll('.ss-nav__details');
    if (!detailsList.length) return;

    updateMegaTop();
    window.addEventListener('resize', updateMegaTop, { passive: true });
    window.addEventListener('scroll', updateMegaTop, { passive: true });

    detailsList.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        updateMegaTop();
        detailsList.forEach(function (other) {
          if (other !== details && other.open) other.removeAttribute('open');
        });
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.ss-nav__details')) return;
      detailsList.forEach(function (d) {
        if (d.open) {
          d.removeAttribute('open');
          var s = d.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      detailsList.forEach(function (d) {
        if (d.open) {
          d.removeAttribute('open');
          var s = d.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  function updateChromeHeight() {
    var chrome = document.getElementById('ss-chrome-header');
    var ticker = document.querySelector('.ss-ticker');
    /* Offset from viewport top to bottom of sticky chrome (not height alone) */
    var bottom = chrome ? chrome.getBoundingClientRect().bottom : 56;
    if (ticker) {
      bottom = Math.max(bottom, ticker.getBoundingClientRect().bottom);
    }
    if (bottom < 0) bottom = chrome ? chrome.offsetHeight : 56;
    document.documentElement.style.setProperty('--ss-chrome-h', Math.round(bottom) + 'px');
  }

  function getDrawerPortal() {
    var host = document.getElementById('ss-drawer-portal');
    if (host) return host;
    host = document.createElement('div');
    host.id = 'ss-drawer-portal';
    host.className = 'ss-drawer-portal';
    host.setAttribute('aria-hidden', 'true');
    host.hidden = true;
    document.body.appendChild(host);
    return host;
  }

  function restoreDrawerNodes(details) {
    if (!details) return;
    var host = document.getElementById('ss-drawer-portal');
    if (!host) return;
    var scrim = host.querySelector('.ss-drawer__scrim');
    var panel = host.querySelector('.ss-drawer__panel');
    if (scrim) details.appendChild(scrim);
    if (panel) details.appendChild(panel);
    host.setAttribute('aria-hidden', 'true');
    host.hidden = true;
    host.innerHTML = '';
  }

  function forceCloseDrawer() {
    var details = document.querySelector('details.ss-drawer');
    if (details && details.open) {
      details.removeAttribute('open');
    }
    document.body.classList.remove('ss-drawer-open');
    document.documentElement.classList.remove('ss-drawer-open');
    unlockDrawerScroll();
    if (details) restoreDrawerNodes(details);
    var host = document.getElementById('ss-drawer-portal');
    if (host) {
      host.hidden = true;
      host.setAttribute('aria-hidden', 'true');
    }
  }

  function lockDrawerScroll() {
    if (document.body.dataset.ssDrawerScrollLocked === '1') return;
    var y = window.scrollY || window.pageYOffset || 0;
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.body.dataset.ssDrawerScrollY = String(y);
    document.body.dataset.ssDrawerScrollLocked = '1';
    document.body.style.top = '-' + y + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
  }

  function unlockDrawerScroll() {
    if (document.body.dataset.ssDrawerScrollLocked !== '1') return;
    var y = parseInt(document.body.dataset.ssDrawerScrollY || '0', 10) || 0;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.paddingRight = '';
    delete document.body.dataset.ssDrawerScrollLocked;
    delete document.body.dataset.ssDrawerScrollY;
    window.scrollTo(0, y);
  }

  function closeOtherOverlaysForDrawer() {
    var openSearch = document.querySelector('.ss-search details[open]');
    if (openSearch) {
      var s = openSearch.querySelector('summary');
      if (s) s.click();
    }
    var cart = document.querySelector('cart-drawer.active');
    if (cart && typeof cart.close === 'function') cart.close();
  }

  function initDrawerClose() {
    updateChromeHeight();
    window.addEventListener('resize', function () {
      updateChromeHeight();
      if (window.matchMedia('(min-width: 990px)').matches) {
        forceCloseDrawer();
      }
    }, { passive: true });

    /* Desktop must never keep a portaled mobile drawer */
    if (window.matchMedia('(min-width: 990px)').matches) {
      forceCloseDrawer();
    }

    document.addEventListener('toggle', function (e) {
      var details = e.target;
      if (!details || !details.classList || !details.classList.contains('ss-drawer')) return;

      /* Block drawer open on desktop */
      if (details.open && window.matchMedia('(min-width: 990px)').matches) {
        details.removeAttribute('open');
        forceCloseDrawer();
        return;
      }

      var isOpen = !!details.open;
      document.body.classList.toggle('ss-drawer-open', isOpen);
      document.documentElement.classList.toggle('ss-drawer-open', isOpen);
      updateChromeHeight();

      var scrim = details.querySelector('.ss-drawer__scrim') || document.querySelector('#ss-drawer-portal .ss-drawer__scrim');
      var panel = details.querySelector('.ss-drawer__panel') || document.querySelector('#ss-drawer-portal .ss-drawer__panel');
      var host = getDrawerPortal();

      if (isOpen) {
        closeOtherOverlaysForDrawer();
        if (window.matchMedia('(max-width: 989px)').matches) {
          if (scrim && scrim.parentElement !== host) host.appendChild(scrim);
          if (panel && panel.parentElement !== host) host.appendChild(panel);
          host.hidden = false;
          host.setAttribute('aria-hidden', 'false');
        }
        lockDrawerScroll();
        if (panel) {
          setTimeout(function () {
            var closeBtn = panel.querySelector('[data-ss-drawer-close]');
            if (closeBtn) closeBtn.focus();
            else panel.focus();
          }, 40);
        }
      } else {
        unlockDrawerScroll();
        restoreDrawerNodes(details);
      }
    }, true);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ss-drawer-close]');
      if (btn) {
        var details = document.querySelector('details.ss-drawer[open]');
        if (details) {
          e.preventDefault();
          details.removeAttribute('open');
          document.body.classList.remove('ss-drawer-open');
          document.documentElement.classList.remove('ss-drawer-open');
          unlockDrawerScroll();
          restoreDrawerNodes(details);
        }
        return;
      }
      if (e.target.classList.contains('ss-drawer__scrim')) {
        var d = document.querySelector('details.ss-drawer[open]');
        if (d && d.open) {
          d.removeAttribute('open');
          document.body.classList.remove('ss-drawer-open');
          document.documentElement.classList.remove('ss-drawer-open');
          unlockDrawerScroll();
          restoreDrawerNodes(d);
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openDrawer = document.querySelector('details.ss-drawer[open]');
      if (!openDrawer) return;
      openDrawer.removeAttribute('open');
      document.body.classList.remove('ss-drawer-open');
      document.documentElement.classList.remove('ss-drawer-open');
      unlockDrawerScroll();
      restoreDrawerNodes(openDrawer);
    });
  }

  function initDrawerSearch() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ss-drawer-search]');
      if (!btn) return;
      e.preventDefault();
      var openDrawer = document.querySelector('details.ss-drawer[open]');
      if (openDrawer) {
        var closeSummary = openDrawer.querySelector('summary');
        if (closeSummary) closeSummary.click();
      }
      var searchSummary = document.querySelector('.ss-search > details > summary');
      if (searchSummary) setTimeout(function () { searchSummary.click(); }, 160);
    });
  }

  function initSearchFocus() {
    document.addEventListener('toggle', function (e) {
      var details = e.target;
      if (!details.matches || !details.matches('.ss-search details')) return;
      if (!details.open) return;
      var input = details.querySelector('.ss-search__input');
      if (input) setTimeout(function () { input.focus(); }, 40);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openSearch = document.querySelector('.ss-search details[open]');
      if (!openSearch) return;
      var summary = openSearch.querySelector('summary');
      if (summary) summary.click();
    });
  }

  function initBackToTop() {
    var btn = document.querySelector('[data-ss-totop]');
    if (!btn) return;

    btn.removeAttribute('hidden');

    var onScroll = function () {
      btn.classList.toggle('is-visible', window.scrollY > 500);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof window.ssClearScrollLocks === 'function') {
        window.ssClearScrollLocks();
      }
      var y = 0;
      document.documentElement.scrollTop = y;
      document.body.scrollTop = y;
      window.scrollTo({ top: y, left: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStickyClass();
    initMegaMenu();
    initDrawerClose();
    initDrawerSearch();
    initSearchFocus();
    initBackToTop();
  });

  document.addEventListener('shopify:section:load', function () {
    initMegaMenu();
  });
})();
